import React from "react";

import Review from "./Review";

function PaymentForm({
  checkoutToken,
  Shippingdata,
  handleCaptureCHeckout,
  nextstep,
}) {
  return (
    <div>
      {" "}
      <div className="">
        <Review
          Shippingdata={Shippingdata}
          handleCaptureCHeckout={handleCaptureCHeckout}
          checkoutToken={checkoutToken}
          nextstep={nextstep}
        />
      </div>
    </div>
  );
}

export default PaymentForm;
